import type { TanstackMutationOptions } from "@@/shared/hooks/use-tanstack-mutation";
import { useTanstackMutation } from "@@/shared/hooks/use-tanstack-mutation";
import type { UseMutationResult } from "@tanstack/react-query";
import type { ViewQuoteCommand } from "@towni/common";

const useViewQuoteCommandMutation = (
    options: TanstackMutationOptions<ViewQuoteCommand> = {},
): UseMutationResult<unknown, unknown, ViewQuoteCommand> => {
    return useTanstackMutation<ViewQuoteCommand>({
        method: "post",
        route: _command => `/quotes/${_command.quoteId}/view`,
        options: {
            ...options,
        },
    });
};

export { useViewQuoteCommandMutation };
